import axios from 'axios';
import { AppSettings } from '../app-settings';
// import { aiStrategyTradesHistoryRequest, aiStrategyTradesOldestDateRequest } from "./api-request-builders/ai-strategy-trades-history-request.builder";
import { AiStrategyTradesJSONToResponseModelMapper } from "./mappers/ai-strategy-trades-json-to-response-model.mapper";
import { AiStrategyTrade } from "./models/ai/ai-strategy-trade";
import { AiStrategyTradesHistoryRequestModel } from "./models/ai/ai-strategy-trades-history-request.model";

export class AiStrategyTradesHistoryClient {

    public async getHistory(request: AiStrategyTradesHistoryRequestModel): Promise<AiStrategyTrade[]> {
        // Kafka path (paid users) — replaced by HTTP endpoint while C++ demo routing is pending
        // const response = await aiStrategyTradesHistoryRequest(request);
        // if (!response) return [];
        // const parsed = JSON.parse(response);
        // if (parsed.SubCommand !== "ai_strategy_trades_history_success") return [];
        // return AiStrategyTradesJSONToResponseModelMapper.map(parsed.Trades ?? []);

        const settings = AppSettings.getInstance();
        const params: Record<string, string> = {
            fromDate: request.fromDate,
            toDate: request.toDate,
            segment: request.segment,
            mode: request.historyMode,
        };
        if (request.tradeId) params['trade_id'] = request.tradeId;

        const response = await axios.get(
            `https://${settings.tiDataServiceHost}/data/v1/ai-strategy-trades/history`,
            {
                params,
                headers: { 'X-Api-Key': atob(settings.tiDemoApiKey) }
            }
        );

        return AiStrategyTradesJSONToResponseModelMapper.map(response.data?.trades ?? []);
    }

    public async getOldestDate(): Promise<Date | null> {
        // Kafka path (paid users) — not available via HTTP demo endpoint
        // const response = await aiStrategyTradesOldestDateRequest();
        // if (!response) return null;
        // const parsed = JSON.parse(response);
        // if (!parsed.OldestDate) return null;
        // const d = new Date(parsed.OldestDate);
        // return isNaN(d.getTime()) ? null : d;
        return null;
    }
}
